import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminApi, ADMIN_TOKEN_KEY, adminErrorMsg } from './adminApiClient';

const AdminAuthContext = createContext(undefined);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshAdmin = useCallback(async () => {
    try {
      const token = localStorage.getItem(ADMIN_TOKEN_KEY);
      if (!token) { setAdmin(null); return null; }
      const res = await adminApi.get('/auth/me');
      setAdmin(res.data);
      return res.data;
    } catch {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      setAdmin(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refreshAdmin().finally(() => setLoading(false));
  }, [refreshAdmin]);

  const login = async (email, password) => {
    try {
      const res = await adminApi.post('/auth/login', { email, password });
      localStorage.setItem(ADMIN_TOKEN_KEY, res.data.access_token);
      const adminData = await refreshAdmin();
      return adminData;
    } catch (e) {
      throw new Error(adminErrorMsg(e));
    }
  };

  const logout = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, isAuthed: !!admin, login, logout, refreshAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
}
